<template>
  <div
    class="next-auctions"
  >
    <Heading
      level="1"
      font-color="linear-gradient(360deg, rgb(41, 38, 103) -100%, rgb(238, 57, 108) 90%)"
      line-height="72px"
      font-size="48px"
      class="next-auctions__title"
    >
      {{ title }}
    </Heading>
    <Heading
      level="2"
      font-color="rgba(0, 0, 0, 0.8);"
      line-height="50px"
      font-size="36px"
      class="next-auctions__subtitle"
    >
      {{ subtitle }}
    </Heading>
    <v-row class="next-auctions__cards">
      <v-col
        v-for="(card, i) in cards"
        :key="i"
        class="fill-height"
      >
        <UpcomingAuctionsCard :card="card"></UpcomingAuctionsCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Heading from '@/components/Heading/Heading.vue';
import UpcomingAuctionsCard from './UpcomingAuctionsCard.vue';

export default {
  name: 'UpcomingAuctions',
  components: {
    Heading,
    UpcomingAuctionsCard,
  },
  data() {
    return {
      title: 'Fique por dentro Próximos leilões',
      subtitle:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore',
      cards: [
        {
          img: require('../../assets/upcoming-auction-1.png'),
          title: 'Manobra',
          description:
            'A marreta que golpeava com violência a imagem projetada na parede anunciava o que estava por vir. No minuto final do vídeo ...',
        },
        {
          img: require('../../assets/upcoming-auction-2.png'),
          title: 'Artistas sem Galeria',
          description:
            '12ª edição do Salão dos Artistas Sem Galeria, promovido pelo Mapa das Artes, realiza, a partir de 14/01/2021, na Lona Galeria de Ar...',
        },
        {
          img: require('../../assets/upcoming-auction-3.png'),
          title: 'Ecologia Fotográfica',
          description:
            '12ª edição do Salão dos Artistas Sem Galeria, promovido pelo Mapa das Artes, realiza, a partir de 14/01/2021, na Lona Galeria de Ar...',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.next-auctions {
  background-color: #f5f5f5;
  position: relative;
  padding: 40px 80px 60px 80px;
  overflow: hidden;
  z-index: 1;
  @media (max-width: $md) {
  padding: 120px 80px 80px 80px;
    padding: 20px;
    padding-top: 35px;
  }

  > * {
    z-index: 10;
    position: relative;
  }

  &::before {
    content: '';
    z-index: 0;
    position: absolute;
    top: -106px;
    left: -446px;
    border: 60px solid #f9f9f9;
    border-radius: 50%;
    width: 1345px;
    height: 1345px;
  }

  &__title {
    width: 35%;
    margin-bottom: 30px;

    @media (max-width: $lg) {
      line-height: 30px !important;
      font-size: 26px !important;
      margin-bottom: 20px;
    }

    @media (max-width: $xxl) {
      width: 100% !important;
    }
  }
  &__subtitle {
    width: 90%;
    @media (max-width: $lg) {
      width: 100% !important;
      line-height: 20px !important;
      font-size: 16px !important;
    }
  }

  &__cards {
    margin-top: 100px;

    @media (max-width: $lg) {
      width: 100%;
      margin-top: 30px;
      overflow-x: scroll;
      flex-wrap: nowrap;
      scroll-snap-type: x mandatory;
    }
  }
}
</style>
